const MuiDialogContent = {
  styleOverrides: {
    root: {
      padding: '24px 24px',
      '&::first-of-type': {
        paddingTop: '24px',
      },
    },
  },
};

export default MuiDialogContent;
